import { useState } from "react"

export const BookingState = () => {
    const [bookings, setBookings] = useState({list: null})
    const [counts, setCounts] = useState({booked: 0, check_in: 0, check_out: 0})
    const [move, setMove] = useState({info: null, submit: {modal: false, type: '', confirmed: false}})
    const [payBalForm, setPayBalForm] = useState({modal: false, mode_payment: '', payment_channel: '', bal_payment: '', payment_ref: '', btnLoader: false, confirmation: false, error: false})
    const [payChannel, setPayChannel] = useState([])
    return {
        bookings: {data: bookings, set: setBookings},
        counts: {data: counts, set: setCounts},
        move: {data: move, set: setMove},
        payBalForm: { data: payBalForm, set: setPayBalForm },
        payChannel: { data: payChannel, set: setPayChannel },
    }
}